export default "__VITE_ASSET__a987aeec__"